var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62502 1.3335C6.62502 0.988318 6.3452 0.708496 6.00002 0.708496C5.65484 0.708496 5.37502 0.988318 5.37502 1.3335L5.37502 9.04183H1.00002C0.747229 9.04183 0.519332 9.19411 0.422594 9.42765C0.325855 9.6612 0.379328 9.93002 0.558077 10.1088L5.55808 15.1088C5.67529 15.226 5.83426 15.2918 6.00002 15.2918C6.16578 15.2918 6.32475 15.226 6.44196 15.1088L11.442 10.1088C11.6207 9.93002 11.6742 9.6612 11.5774 9.42765C11.4807 9.19411 11.2528 9.04183 11 9.04183H6.62502L6.62502 1.3335Z",
    fill: "#F34F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDownArrow);
export default __webpack_public_path__ + "static/media/redDownArrow.a5c6cead581235586aedeb425972fb6a.svg";
export { ForwardRef as ReactComponent };